import { useEffect } from "react";
import { useRef } from "react";
import * as echarts from "echarts";

const ChartIAInsight = ({ chart }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current || !chart?.data?.length) return;

    const chartInstance = echarts.init(chartRef.current);

    const labels = chart.data.map((item) => item.label);
    const values = chart.data.map((item) => Number(item.value || 0));

    let option = {
      backgroundColor: "transparent",
      title: {
        text: chart.title || "",
        left: 20,
        top: 12,
        textStyle: {
          fontSize: 15,
          fontWeight: 700,
          color: "#1f2937",
        },
      },
      tooltip: {
        show: false,
      },
      grid: {
        top: 70,
        left: 72,
        right: 32,
        bottom: 72,
      },
      xAxis: {
        type: "category",
        name: chart.xLabel || "",
        data: labels,
        axisLine: {
          lineStyle: {
            color: "#cbd5e1",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#64748b",
          rotate: labels.some((label) => label.length > 15) ? 18 : 0,
          fontSize: 11,
        },
        nameTextStyle: {
          color: "#64748b",
          padding: [12, 0, 0, 0],
        },
      },
      yAxis: {
        type: "value",
        name: chart.yLabel || "",
        splitLine: {
          lineStyle: {
            color: "#eef2f7",
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#64748b",
          fontSize: 11,
        },
        nameTextStyle: {
          color: "#64748b",
          padding: [0, 0, 8, 0],
        },
      },
      series: [],
      animation: false,
    };

    if (chart.chartType === "line") {
      option.series = [
        {
          type: "line",
          data: values,
          smooth: true,
          symbol: "circle",
          symbolSize: 8,
          lineStyle: {
            width: 3,
            color: "#2563eb",
          },
          itemStyle: {
            color: "#2563eb",
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(37, 99, 235, 0.22)" },
                { offset: 1, color: "rgba(37, 99, 235, 0.02)" },
              ],
            },
          },
        },
      ];
    }

    if (chart.chartType === "bar") {
      option.series = [
        {
          type: "bar",
          data: values,
          barWidth: "42%",
          itemStyle: {
            borderRadius: [8, 8, 0, 0],
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "#2563eb" },
                { offset: 1, color: "#93c5fd" },
              ],
            },
          },
        },
      ];
    }

    if (chart.chartType === "pie") {
      option = {
        title: {
          text: chart.title || "",
          left: "center",
          textStyle: {
            fontSize: 14,
            fontWeight: 600,
          },
        },
        series: [
          {
            type: "pie",
            radius: ["42%", "68%"],
            center: ["50%", "56%"],
            data: chart.data.map((item) => ({
              name: item.label,
              value: Number(item.value || 0),
            })),
            label: {
              formatter: "{b}\n{d}%",
              color: "#475569",
              fontSize: 11,
            },
            itemStyle: {
              borderRadius: 8,
              borderColor: "#ffffff",
              borderWidth: 3,
            },
          },
        ],
        animation: false,
      };
    }

    chartInstance.setOption(option);

    const handleResize = () => {
      chartInstance.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chartInstance.dispose();
    };
  }, [chart]);

  return <div className="assistant-chart" ref={chartRef} />;
};

export default ChartIAInsight;
